import BarChart from "../tools/BarChart";
import BarChart2 from "../tools/BarChart2";

export const BonusGraph = ({data,className, days, onTabChange, bonusList, onBonusTabChange ,name}) => {
  // const formatRupees = (value) => {
  //   const n = Number(value) || 0;
  //   return new Intl.NumberFormat("en-IN", {
  //     minimumFractionDigits: 2,
  //     maximumFractionDigits: 2,
  //   }).format(n);
  // };
  
  return (
    <>
      <BarChart2
        name={name}
        data={data}
        className={className}
        days={days}
        onTabChange={onTabChange}
        onBonusTabChange={onBonusTabChange}
        bonusList={bonusList}
      />
    </>
  );
};
